import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/ui/themes";

const appearance = {
  theme: dark,
  captcha: { theme: "dark" },
  layout: { logoImageUrl: "/calibrunway-mark.png", logoLinkUrl: "/" },
  variables: {
    colorPrimary: "#00FF9D",
    colorPrimaryForeground: "#050505",
    colorBackground: "#121212",
    colorInput: "#0A0A0A",
    colorBorder: "#2A2A2A",
    fontFamily: "IBM Plex Sans, sans-serif",
    borderRadius: "0.75rem",
  },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const localization = {
  signIn: { start: { title: "Sign in to CalibRunway", titleCombined: "Continue to CalibRunway", subtitle: "Welcome back. Your runway is calibrated and waiting.", subtitleCombined: "Welcome back. Your runway is calibrated and waiting." } },
  signUp: { start: { title: "Start calibrating with CalibRunway", titleCombined: "Start calibrating with CalibRunway", subtitle: "14 days free. No card required.", subtitleCombined: "14 days free. No card required." } },
};

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>Sign-in is unavailable right now. Refresh the page to try again.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={localization}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
